import React, { Component } from 'react';
import qrcode from './qrcode.jpg';
import './qrcode.css';

let FootStyle = {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
    padding: '12px',
    color: '#888',
    backgroundColor: '#f8f8f8',
    borderTop: '1px solid #e7e7e7'
};


class QRCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            top: (window.innerHeight - 400) / 2,
            beiAn: '粤ICP备14083998号',
            beiAnLink: 'https://beian.miit.gov.cn/#/Integrated/index',
        };
        this.windowResize = this.windowResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.windowResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize);
    }

    windowResize() {
        this.setState({
            top: (window.innerHeight - 400) / 2
        });
    }

    render() {
        return (
            <div className="QRCode">
                <div className="QRCode-header" style={{ marginTop: this.state.top }}>
                    <img src={qrcode} className="QRCode-logo" alt="logo" />
                    <h2>IMCP综合监控</h2>
                </div>
                <div style={FootStyle}>
                    &copy;2006-2023 版权所有：深圳市纵横通信息技术有限公司 ┆ 总部地址：深圳市龙华区民治街道上芬社区龙胜路与景龙建设路交汇处融创智汇大厦3座1009 ┆ <a href={this.state.beiAnLink} target="_blank">{this.state.beiAn}</a> ┆ 本站点仅用作微信服务号“IMCP综合监控”后台服务
                </div>
            </div>
        );
    }
}

export default QRCode;



// WEBPACK FOOTER //
// ./src/qrcode.js